import { Immutable } from "immer";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormItem } from "@/components/ui/form";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { CmsRowBlock } from "@/gen/realtime";

import { FormControl, FormLabel } from "./shared";

const containerSizings = [
    { key: "Show All", value: { t: "showAll", c: null } },
    { key: "Scrolling carousel", value: { t: "scrolling", c: { size: { t: "sm" } } } },
] as const;

export const RowForm = ({
    block,
    setBlock,
}: {
    block: Immutable<CmsRowBlock>;
    setBlock: (mutate: (block: CmsRowBlock) => void) => void;
}) => {
    return (
        <div className="flex-grow space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Row Type</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="flex flex-row gap-4">
                        {containerSizings.map(kind => (
                            <Button
                                key={kind.key}
                                onClick={() => {
                                    setBlock(block => {
                                        block.sizing = kind.value;
                                    });
                                }}
                                variant={block.sizing.t === kind.value.t ? "default" : "outline"}
                            >
                                {kind.key}
                            </Button>
                        ))}
                    </div>
                    <RowSizingForm block={block} setBlock={setBlock} />
                </CardContent>
            </Card>
        </div>
    );
};

const RowSizingForm = ({
    block,
    setBlock,
}: {
    block: Immutable<CmsRowBlock>;
    setBlock: (mutate: (block: CmsRowBlock) => void) => void;
}) => {
    switch (block.sizing.t) {
        case "showAll":
            return null;
        case "scrolling":
            return (
                <FormItem>
                    <FormLabel className="text-md font-bold">Size</FormLabel>
                    <FormControl>
                        <Select
                            onValueChange={val => {
                                setBlock(block => {
                                    if (block.sizing.t === "scrolling") {
                                        block.sizing.c.size.t = val as "sm" | "md";
                                    }
                                });
                            }}
                            defaultValue={block.sizing.c.size.t}
                        >
                            <SelectTrigger className="w-[180px]">
                                <SelectValue placeholder="Size" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="sm">Small</SelectItem>
                                <SelectItem value="md">Medium</SelectItem>
                            </SelectContent>
                        </Select>
                    </FormControl>
                </FormItem>
            );
        default:
            return null;
    }
};
